type Result = { [key: number | string]: true };

export const getArrayToObject = (arr: number[]): Result => {
  return arr.reduce((acc, value) => {
    acc[value] = true;
    return acc;
  }, {} as Result);
};
